import type { Me, Permission, Scope } from "../api/contracts";
import { hasGrant } from "../rbac/grants";

// The shell's surface-registry PRIMITIVE (ADR 0015 §10/§13). The foundation owns
// the type and the RBAC gating; each app supplies its own list of surfaces (the
// per-app registry) and passes it to the shell. A surface declares the grant that
// makes it visible — the nav is computed from the principal, so a staff member
// sees only their own surfaces. The API still enforces every call (this is UX).
//
// `labelKey` is generic so an app keeps compile-time key-safety against its own
// message dictionary (`Surface<AppMessageKey>`), while the foundation shell renders
// the label through a string-typed translate (the merged dictionary resolves it).
export interface Surface<TLabelKey extends string = string> {
  key: string;
  path: string;
  labelKey: TLabelKey;
  /** Visible if the principal holds this permission at >= scope. Omitted = any staff. */
  requires?: { permission: Permission; scope: Scope };
}

export function visibleSurfaces<T extends string>(
  me: Me | null,
  surfaces: Surface<T>[],
): Surface<T>[] {
  if (!me) return [];
  return surfaces.filter((s) => {
    if (!s.requires) return me.type === "staff";
    return hasGrant(me, s.requires.permission, s.requires.scope);
  });
}
